// const { event } = require("jquery");


// let is_mobile = is_mobile;
import React, {useState, useEffect, useContext} from "react"
import ReactModal from "react-modal";
import SglContext from "../SglContext";
import axios from "axios";
import { Link } from "react-router-dom";
// import './channels.css'
var AddModal = ReactModal;
// var Link = ReactRouterDOM.Link;


function OnDemand(props){// extends React.Component {
  
    // state = {
        
    //     is_user_authorized: false,
    //     total_rows: 0,
    //     channels_list: [],
    //     is_mobile: false,
        
    //     loading: true,
    //     userData: {},
    //     login_people_id: -1,

    // };
    const [is_user_authorized, setIs_user_authorized] = useState(false)
    const [total_rows, setTotal_rows] = useState(0)
    const [channels_list, setChannels_list] = useState([])
    const [is_mobile, setIs_mobile] = useState(false)

    const [loading, setLoading] = useState(true)
    const [userData, setUserData] = useState({})
    const [login_people_id, setLogin_people_id] = useState(-1)
    const Sgl = useContext(SglContext)

    const sgl_webservice_channels_list = Sgl.nestApiUrl + "/channels";
    const user_info_url = Sgl.nestApiUrl + "/users/getUser";

    // constructor(props) {
    //     super(props);
    //     // bind function in constructor instead of render
    //     onChangePage = onChangePage.bind(this);
    // }

    // componentDidMount() {
    //     getChannelsData();
    //     // if (is_mobile == 1) {
    //     //   setState({
    //     //     is_mobile: is_mobile,
    //     //   });
    //     // }
    // }

    useEffect(() => { 
        getChannelsData();
    }, [])


    function getChannelsData() {
        
        axios
        .get(sgl_webservice_channels_list, {
            params: {
                channel_type: 'ondemand',
                customer_id: Sgl.company_id,
            },
        })
        .then((res) => {
          Sgl.reportToGA('/sgl-wp-plugin/'+Sgl.company_urlpath+'/channels/ondemand/list');
          Sgl.reportToFB('/sgl-wp-plugin/'+Sgl.company_urlpath+'/channels/ondemand/list');
            // setState({
            //     // is_user_authorized: res.data.is_user_authorized,
            //     channels_list: res.data.channels_list,
            //     total_rows: res.data.total_records,
                
            //     loading: false,
            // });
            // setIs_user_authorized(res.data.is_user_authorized)
            setChannels_list(res.data.channels_list)
            setTotal_rows(res.data.total_records)
            setLoading(false)
        });
    }

  
    function getUserData() {
    axios.get(user_info_url).then(
      (response) => {
        if (response.data.user && response.data.user != null) {
        //   setState({
        //     userData: response.data.user,
        //     login_people_id: response.data.user.sgl_id
        //   });
        setUserData(response.data.user)
        setLogin_people_id(response.data.user.sgl_id)
        }
      },
      (error) => {}
    );
    
  }

  function onChangePage(page) {
    getChannelsData();
  }

//   render() {
//     const loading = loading;
    if (loading) {
      return null;
    }
    return (
      <div className="sgl-plugin section-to-print livestreamcss">
        {/* <div className=''>
          <h1>Video on Demand </h1>
        </div>
        <div>
            <p className='channel_description'>
                Welcome to the ShowGroundsLive.com Video Channels!
                <br/><br/>
                The video channels below are dynamic channels pulled from our large library of video. They have been organized into channels that we hope will meet a variety of interests. These video channels are provided on a subscription basis and can be purchased for a single day, a 7 day period or a monthly period. Subscribing to our VOD Channel service will also allow access to live ring streaming when rings are active and underway.
                <br/><br/>
                We hope you enjoy the service and we welcome your feed back at suggestions@showgroundslive.com.
            </p>
        </div> */}
        <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div><br/>
        <div
          id="channels_listing" className='grid'
        >
          <div className="flex-video-container">
          
            {total_rows > 0 ? (
              channels_list.map((channel, index) => {
                return (
                  <div className="video_container ">
                    <div className="video-content">
                      
                        <div className="thumb-image">
                            <Link className='cursor-pointer' to={'/demand-channels/detail?demand_channel='+channel.sgl_id+'&v_id=-1'}>
                                <img className='display_thumb_img' src={channel.logo} />  
                            </Link>
                        </div>
                        <div className="video_details">
                            
                            <div>
                                <Link className='cursor-pointer' to={'/demand-channels/detail?demand_channel='+channel.sgl_id+'&v_id=-1'}>
                                    <span className="channel_details link_color">
                                        {channel.name}
                                        <br/>
                                    </span>
                                    <span className="channel_stats link_color">
                                        {channel.channel_stats}   
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                  </div>
                );
              })
            ) : (
                <div className="video_container ">
                    <div className="video-content">
                    <div className="thumb-image">
                        {/* <img src={horse_logo} /> */}
                        <span className="float-left">No channels Found</span>
                    </div>
                    </div>
                </div>
            )}
          </div>
        </div>
        <div className="copyright-text">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
      </div>
    );
//   }
}
// ReactDOM.render(<OnDemand />, document.getElementById("sgl-content-wrapper"));
export default OnDemand
